const HELP_TEXTS = {
  transferBudget: {
    account:
      'Transfers will occur only between campaigns associated with this account.',
    totalBudget:
      'If product has a management fee, the budget is calculated with this formula:\n · netClientBudget = netClientBudgetExternal + wkzBudget \n· netBudget = (netClientBudget / (1 - headerDiscount)) + coInvest\n · spendableBudget = (netBudget / (1 + adjustedFee)) + freeService',
    sourceDelta:
      'Media Team should remove exactly the amount outlined in this delta value.',
    targetDelta:
      'Media team should add exactly the amount outlined in this delta value.',
  },
  changeProductBudget: {
    totalBudget: 'After Mngmt. Fee deduction',
  },
};

export default HELP_TEXTS;
